import Item from './item';
import or from 'ember-truth-helpers/helpers/or';

import type { TemplateOnlyComponent } from '@ember/component/template-only';
import type { ComponentLike } from '@glint/template';

interface BvConnectedSignature {
  Args: {
    left?: ComponentLike;
    right?: ComponentLike;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

const BvConnectedComponent = <template>
  {{#if (or @left @right)}}
    <div class='bv-connected' ...attributes>
      {{#if @left}}
        <Item data-test-connected-item='left' @position='left'>
          {{@left}}
        </Item>
      {{/if}}
      <Item data-test-connected-item='primary' @position='primary'>
        {{yield}}
      </Item>
      {{#if @right}}
        <Item data-test-connected-item='right' @position='right'>
          {{@right}}
        </Item>
      {{/if}}
    </div>
  {{else}}
    {{yield}}
  {{/if}}
</template> satisfies TemplateOnlyComponent<BvConnectedSignature>;

export default BvConnectedComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvConnected: typeof BvConnectedComponent;
    'bv-connected': typeof BvConnectedComponent;
  }
}
